import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { ProduccionesApi } from "../api/ProduccionesApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { FiltrosProducciones } from "./FiltrosProducciones";
import { ProduccionesTable } from "./Table/ProduccionesTable";
import { useDebounce } from "../../../../../../Utils/Hooks/useDebounce";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../utility/utils";
import { DetalleOrdenes } from "./DetalleOrdenes";

export const Listado = ({ storageKey, estado }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";
    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [producciones, setProducciones] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const { getProducciones, deleteProduccion, cargando } = ProduccionesApi();

    const GetProducciones = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
                estado: estado,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getProducciones(params);
            setProducciones(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las producciones",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setProducciones([]);
            setCantidadResultados(0);
        }
    };

    const EliminarProduccion = async (id) => {
        try {
            await deleteProduccion(id);
            NotificationManager.success(
                "Producción eliminada correctamente",
                "Éxito",
                3000,
            );
            GetProducciones();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar producción",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetProducciones();
    }, [debouncedSearch, fecha_inicial, fecha_final, paginaSeleccionada]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, fecha_inicial, fecha_final, paginaSeleccionada]);

    const [produccionSeleccionada, setProduccionSeleccionada] = useState(null);

    return (
        <div className="view__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="producciones__table-header">
                        <FiltrosProducciones
                            control={control}
                            onRefresh={() => {
                                GetProducciones();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Número de producción"}
                        />
                        <Link to={`/produccion-v2/crear-produccion`}>
                            <button className="btn btn-primary">
                                Crear producción
                            </button>
                        </Link>
                    </div>

                    <ProduccionesTable
                        producciones={producciones}
                        EliminarProduccion={EliminarProduccion}
                        estado={estado}
                        setProduccionSeleccionada={setProduccionSeleccionada}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>

            <DetalleOrdenes
                produccionSeleccionada={produccionSeleccionada}
                onClose={() => setProduccionSeleccionada(null)}
            />
        </div>
    );
};
